import { Injectable } from '@angular/core';
import { BuildSearchFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class SubscriptionSearchFilter extends BuildSearchFilter('SubscriptionSearchFilter', {
  properties: ['user.email', 'user.displayName', 'items.displayName', 'user.contactEmail'],
  propertyLabels: ['Email Address', 'Customer Name', 'Items'],
}) {}
